import React from "react";
import { useSelector } from "react-redux";
import { getOrderNumber, getPayUrl } from "../../store/order/selectors";
import { getCardPayUrl, getSbpPayUrl } from "../../utils/payUrlGenerator";

function ShopCartPaymentInfo({ shop }) {
  const orderNumber = useSelector(getOrderNumber(shop));
  const payUrl = useSelector(getPayUrl(shop));
  return (
    <div className="payment-info">
      <div className="mb-3 flex w-full flex-col gap-2">
        <span className="font-semibold">Оплата заказа:</span>
        <span>
          Для оплаты заказа #{orderNumber} воспользуйтесь ссылкой:{" "}
          <a href={getSbpPayUrl(payUrl)} className="link" target="_blank" rel="noreferrer">
            Оплатить
          </a>
        </span>
        <span>
          Если у вас не получилось оплатить по ссылке выше, то воспользуйтесь этой ссылкой:{" "}
          <a href={getCardPayUrl(payUrl)} className="link" target="_blank" rel="noreferrer">
            Оплата (способ 2)
          </a>
        </span>
        <span className="mt-2">
          Для получения кодов, вам необходимо оплатить счёт в течение 10 мин. После успешной оплаты коды придут на указанную в заказе почту в течение пары минут (редко дольше - до 25 минут).
        </span>
        <span className="mt-2">
          Так же можете{" "}
          <a
            href="#payment-status-check"
            className="link"
            onClick={() => {
              const btn = document.getElementById(
                "payment-status-check-button"
              );
              if (btn) {
                setTimeout(() => btn.click(), 0);
              }
            }}
          >
            проверить статус оплаты здесь
          </a>{" "}
          и получить коды.
        </span>
        <span className="mt-2">
          <span className="text-red-600 font-semibold">Внимание!</span> Если вы оплатили заказ, но письмо с кодами не приходит, то проверьте папку <span className="font-semibold">Спам</span>.
        </span>
        <span>
          Если оно оказалось с этой папке, отметьте пожалуйста письмо как <span className="font-semibold">Не спам.</span>
        </span>
      </div>
    </div>
  );
}

export default ShopCartPaymentInfo;
